/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PurchaseApi } from '../api/purchase.api';
import { switchMap, map } from 'rxjs/operators';
import { PurchaseData, Purchase, SupplierInvoice } from '../../../interfaces/masters/purchase';

@Injectable()
export class PurchaseService extends PurchaseData {

  constructor(private api: PurchaseApi) {
    super();
  }



  list(url: string): Observable<Purchase[]> {
    return this.api.list(url);
  }
searchList(url: string,data:any): Observable<any> {
   
      return this.api.searchList(url,data);
    }
     distinctSupplier(url: string): Observable<any> {
    return this.api.distinctSupplier(url);
    }
    consolidSupplierWiseReport(url: string,data:any): Observable<any> {
   
      return this.api.searchList(url,data);
    }
     consolidDateWiseReport(url: string,data:any): Observable<any> {
    
      return this.api.searchList(url,data);
    }
 supplierList(url: string): Observable<Purchase[]> {
  
    return this.api.list(url);
  }
  supplierInvoiceListById(url: string): Observable<SupplierInvoice> {
 
    return this.api.invoiceListById(url);
  }
  supplierInvoiceList(url: string): Observable<SupplierInvoice[]> {

    return this.api.invoiceList(url);
  }
  getById(url:string): Observable<Purchase>{
      return this.api.getById(url);
  }

  create(url: string, data:Purchase): Observable<Purchase> {
    return this.api.add(url,data);
  }

  searchSupplier_Inv_List(url: string,data:any): Observable<any> { 
   
    return this.api.searchSupplier_Inv_List(url,data);
  }

  update(url: string, data:Purchase): Observable<Purchase> {
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  
  searchInv_List(url: string): Observable<Purchase[]> {
    return this.api.searchInv_List(url);
  }

}
